import { textClient } from '../lib/api';

function EntryIndex() {
  return {
    activeFilter: false,
    state: 'idle',
    handleFilterUpdate({ detail }) {
      const { option } = detail;

      // Did the user select the already applied filter?
      if (this.activeFilter.slug === option.slug) {
        return;
      }

      this.activeFilter = option;

      const { url } = this.activeFilter;
      this.fetchData(url).then(html => {
        this.state = 'idle';
        this.$refs.contentBody.innerHTML = html;
        window.history.pushState(option, null, url);
      });
    },

    handleHistoryPop(event) {
      /**
       * Passing $dispatch is kind of a hassle here, so we just mimic
       * its functionality
       */
      window.dispatchEvent(
        new CustomEvent('filter-update', {
          detail: { option: event.state },
        })
      );
    },

    fetchData(url) {
      this.state = 'loading';
      return textClient(url).catch(error => {
        this.state = 'error';
        // eslint-disable-next-line no-console
        console.error(error);
      });
    },
  };
}

export default EntryIndex;
